import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AppLayout from './components/AppLayout';
import LandingMonica from './pages/LandingMonica';
import Auth from './pages/Auth';
import HomePage from './pages/HomePage';
import ICPGenerator from './pages/ICPGeneratorNew';
import FunnelBuilder from './pages/FunnelBuilder';
import BusinessList from './pages/BusinessList';
import BusinessContentView from './pages/BusinessContentView';
import CampaignGenerator from './pages/CampaignGenerator';
import ContentGenerator from './pages/ContentGenerator';
import ScriptGeneratorNew from './pages/ScriptGeneratorNew';
import Planner333 from './pages/Planner333New';
import Onboarding from './pages/Onboarding';
import MonicaWizard from './pages/MonicaWizard';
import { Toaster } from './components/ui/sonner';
import './App.css';

// Wrapper component for pages that use the AppLayout
const WithLayout = ({ children }) => (
  <AppLayout>{children}</AppLayout>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<LandingMonica />} />
            <Route path="/app/auth" element={<Auth />} />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <WithLayout><HomePage /></WithLayout>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/businesses" 
              element={
                <ProtectedRoute>
                  <WithLayout><BusinessList /></WithLayout>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/business-content/:businessId" 
              element={
                <ProtectedRoute>
                  <WithLayout><BusinessContentView /></WithLayout>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/icp" 
              element={
                <ProtectedRoute>
                  <WithLayout><ICPGenerator /></WithLayout>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/campaign-generator" 
              element={
                <ProtectedRoute>
                  <WithLayout><CampaignGenerator /></WithLayout>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/content-generator" 
              element={
                <ProtectedRoute>
                  <WithLayout><ContentGenerator /></WithLayout>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/script-generator" 
              element={
                <ProtectedRoute>
                  <WithLayout><ScriptGeneratorNew /></WithLayout>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/funnel-builder" 
              element={
                <ProtectedRoute>
                  <WithLayout><FunnelBuilder /></WithLayout>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/planner-333" 
              element={
                <ProtectedRoute>
                  <WithLayout><Planner333 /></WithLayout>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/onboarding" 
              element={
                <ProtectedRoute>
                  <Onboarding />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/monica" 
              element={
                <ProtectedRoute>
                  <WithLayout><MonicaWizard /></WithLayout>
                </ProtectedRoute>
              } 
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
